import { Guid } from "guid-typescript";

class TimetablePassenger {

    // TODO: Guid, not string
    timetableId: Guid;
     // TODO: int, not number
    passengerId: number;

      // TODO: Params: Guid (not string), int (not number)
    constructor(timetableId: Guid, passengerId: number) {
        this.timetableId = timetableId;
        this.passengerId = passengerId;
    }
}

export default TimetablePassenger;
